export default defineNuxtRouteMiddleware((_to, _from) => {
  const nuxtApp = useNuxtApp()
  if (nuxtApp.$store.getters.profile?.internal && !nuxtApp.$store.getters.pro) {
    return navigateTo('/account/pro')
  }
})
